import './bg.css'

const Background = () => {

      return (
            <div className="backgrount_content">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="circle_shape"></div>
                  <div className="circle_shape"></div>
                  <div className="rectangle_shape"></div>
                  <div className="rectangle_shape"></div>
            </div>
      )
}

export default Background
